"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { getPageType } from "@repo/shared-utils/common-utils";
import { CTPageView } from "@repo/analytics/data-layer-utils";

const TAG_POLL_INTERVAL_MS = 100;
const TAG_POLL_MAX_MS = 2000;
const DEDUPE_WINDOW_MS = 3000;

const waitForPageViewEvent = async (): Promise<string> => {
  const deadline = Date.now() + TAG_POLL_MAX_MS;

  while (Date.now() < deadline) {
    const eventName = getPageType("tag-7");
    if (eventName) {
      return eventName;
    }
    await new Promise((resolve) => setTimeout(resolve, TAG_POLL_INTERVAL_MS));
  }

  return "";
};

export default function RouteChangePageView() {
  const pathname = usePathname();
  const lastFireRef = useRef<{ key: string; at: number } | null>(null);

  useEffect(() => {
    let cancelled = false;

    const firePageView = async () => {
      const eventName = await waitForPageViewEvent();
      if (cancelled || !eventName) {
        return;
      }

      const dedupeKey = `${pathname}|${eventName}`;
      const now = Date.now();
      const lastFire = lastFireRef.current;

      if (lastFire?.key === dedupeKey && now - lastFire.at < DEDUPE_WINDOW_MS) {
        return;
      }

      lastFireRef.current = { key: dedupeKey, at: now };
      CTPageView(eventName);
    };

    void firePageView();

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
